<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Cancel & Invoice Report
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateRangeLabel"
              label="Select Date [Start - End]"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            range
            :max="nowDate"
            @click:date="dateSelect"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="search_doctor_id"
          :items="doctors"
          item-text="dr_name"
          item-value="id"
          label="Select Doctor"
          prepend-icon="mdi-doctor"
          clearable
          dense
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="2">
        <v-row align="center" justify="space-around">
          <v-btn
            depressed
            color="primary"
            append-icon="mdi-printer"
            @click="printReport"
          >Print Report
          </v-btn>
        </v-row>
      </v-col>
    </v-card-title>
    <div id="print">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.operation_subhead="{ item }">
            <span v-if="item.operation">{{ item.operation.name }}</span>
            <v-chip
              v-if="item.operation_subhead"
              class="ma-2"
              color="error"
              outlined
              small
            >
              {{ item.operation_subhead }}
            </v-chip>
          </template>
          <template v-slot:item.opp_date="{ item }">
            {{ formatDate(item.opp_date) }}
          </template>
          <template v-slot:item.cancel_date="{ item }">
            <div>{{ formatDate(item.cancel_date) }}</div>
            <small v-if="item.cancel_time">{{ item.cancel_time }}</small>
          </template>
          <template v-slot:item.paid_amount="{ item }">
            <div class="d-flex justify-center font-weight-black">
              {{ b_number_format(item.paid_amount) }}
            </div>
          </template>
          <template v-slot:item.invoice_summary="{ item }">
            <div v-if="item.invoice_summary && item.invoice_summary.length">
              <div
                v-for="(invoice, index) in item.invoice_summary"
                :key="invoice.invoice_id + '-' + index"
                class="mb-1"
              >
                <strong>{{ invoice.invoice_id }}</strong>
                | {{ formatDate(invoice.invoice_date) }}
                | <v-chip x-small :color="invoice.invoice_status === 'void' ? 'error' : 'success'" dark>
                  {{ (invoice.invoice_status || '').toUpperCase() }}
                </v-chip>
                | {{ b_number_format(invoice.paid_amount) }}
                <div v-if="invoice.void_date" class="grey--text text--darken-1">
                  Void: {{ formatDate(invoice.void_date) }}
                  <span v-if="invoice.void_by"> by {{ invoice.void_by }}</span>
                </div>
                <div v-if="invoice.void_description" class="grey--text text--darken-1">
                  {{ invoice.void_description }}
                </div>
              </div>
            </div>
            <span v-else class="grey--text">No invoice</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  @click="ot_details(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="orange"
                  label
                  outlined
                  small
                >
                  <v-icon> mdi-chevron-double-right </v-icon>
                </v-chip>
              </template>
              <span>OT Registration Details</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      date: [
        moment().format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      nowDate: moment().format("YYYY-MM-DD"),
      menu2: false,
      loadingstatus: true,
      login_user_id: localStorage.getItem("userId"),
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      search_doctor_id: "",
      doctors: [],
      headers: [
        { text: "SL #", value: "sno" },
        { text: "OT ID", align: "start", value: "registration_no" },
        { text: "OT Date", value: "opp_date" },
        { text: "Cancel Date", value: "cancel_date" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Operation", sortable: true, value: "operation_subhead" },
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Invoice / Void Info", value: "invoice_summary", sortable: false },
        { text: "Cancel Note", value: "cancel_description" },
        { text: "Cancel By", value: "cancel_by.full_name" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      items: [
        { text: "Dashboard", disabled: false, href: "/" },
        { text: "OT Bill", disabled: true },
        { text: "Cancel Report", disabled: true },
      ],
    };
  },
  created() {
    this.getDoctors();
    if (this.isDateRangeComplete) {
      this.initialize();
    } else {
      this.loadingstatus = false;
    }
  },
  watch: {
    search_doctor_id() {
      if (this.isDateRangeComplete) {
        this.initialize();
      }
    },
  },
  computed: {
    normalizedDateRange() {
      const dates = Array.isArray(this.date)
        ? this.date.filter(function (selectedDate) {
          return !!selectedDate;
        })
        : [];

      if (dates.length < 2) {
        return null;
      }

      return dates.slice(0, 2).sort();
    },
    isDateRangeComplete() {
      return this.normalizedDateRange !== null;
    },
    dateRangeLabel() {
      const range = this.normalizedDateRange;
      if (range) {
        if (range[0] === range[1]) {
          return range[0];
        }
        return range[0] + " to " + range[1];
      }

      const pendingDates = Array.isArray(this.date)
        ? this.date.filter(function (selectedDate) {
          return !!selectedDate;
        })
        : [];

      if (pendingDates.length === 1) {
        return pendingDates[0] + " (select end date)";
      }

      return "";
    },
    itemsWithSno() {
      return this.desserts.map(function (row, index) {
        return Object.assign({}, row, { sno: index + 1 });
      });
    },
  },
  methods: {
    validateSelectedDate() {
      const dates = this.normalizedDateRange || (
        Array.isArray(this.date)
          ? this.date.filter(function (selectedDate) {
            return !!selectedDate;
          })
          : []
      );
      const hasFutureDate = dates.some(function (selectedDate) {
        return selectedDate && selectedDate > this.nowDate;
      }.bind(this));

      if (hasFutureDate) {
        this.$noty.error("Future date cannot be selected");
        this.date = [this.nowDate, this.nowDate];
        return false;
      }

      return true;
    },
    initialize() {
      if (!this.isDateRangeComplete) {
        this.loadingstatus = false;
        return;
      }
      if (!this.validateSelectedDate()) {
        this.loadingstatus = false;
        return;
      }

      const dateQuery = this.normalizedDateRange.join(",");
      const doctorQuery = this.search_doctor_id
        ? "&doctor_id=" + this.search_doctor_id
        : "";
      this.loadingstatus = true;
      atshq
        .get("ot-module/ot-bill-cancel?date=" + dateQuery + doctorQuery)
        .then((response) => {
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.loadingstatus = false;
          const message = e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : "Failed to load cancel report";
          this.$noty.error(message);
        });
    },
    getDoctors() {
      atshq
        .get("doctors?status=1&dr_type=" + encodeURIComponent("Specialist Doctor"))
        .then((response) => {
          this.doctors = response.data.data;
        })
        .catch(() => {
          this.$noty.error("Failed to load doctor list");
        });
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }
      return moment(value).format("DD MMM, YYYY");
    },
    b_number_format(n) {
      const amount = parseFloat(n || 0);
      return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    dateSelect() {
      if (!this.isDateRangeComplete) {
        this.loadingstatus = false;
        return;
      }
      if (!this.validateSelectedDate()) {
        this.loadingstatus = false;
        return;
      }
      this.date = this.normalizedDateRange.slice();
      this.menu2 = false;
      this.initialize();
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    printReport() {
      if (!this.isDateRangeComplete) {
        this.$noty.error("Please select start and end date");
        return;
      }
      if (!this.validateSelectedDate()) {
        return;
      }
      const doctorQuery = this.search_doctor_id
        ? "&doctor_id=" + this.search_doctor_id
        : "";
      window.open(
        this.returnApiBaseURL
          + "print/ot-cancel-invoice-report?date="
          + this.normalizedDateRange.join(",")
          + doctorQuery
          + "&login_user_id="
          + this.login_user_id
      );
    },
  },
};
</script>
